import { respCodeCheck } from "./error";

export const getPackages = async (resourceKey: string) => {
  const result = await fetch(`/api/v2/payment/package`, {
    method: "POST",
    body: JSON.stringify({
      // package_type: 1,
      offset: 0,
      limit: 100,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const getPrice = async (
  account_id: number,
  package_id: number,
  sub_account_count: number | undefined,
  resourceKey: string,
  isUpgrade: boolean,
) => {
  const result = await fetch(`/api/v2/payment/price`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      package_id,
      sub_account_count,
      platform_id: 1,
      is_upgrade: isUpgrade,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const getPriceV2 = async ({
  account_id,
  package_id,
  sub_account_count,
  resourceKey,
  isUpgrade,
  discountCode,
  couponType,
}: {
  account_id: number;
  package_id: number;
  sub_account_count: number | undefined;
  resourceKey: string;
  isUpgrade: boolean;
  discountCode?: string;
  couponType?: string;
}) => {
  const result = await fetch(`/api/v2/payment/price`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      package_id,
      sub_account_count,
      platform_id: 1,
      is_upgrade: isUpgrade,
      discount_coupon_code: couponType,
      private_domain_code: discountCode,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const createTrade = async (
  account_id: number,
  package_id: number,
  platform_id: number,
  sub_account_count: number | undefined,
  resourceKey: string,
  isUpgrade: boolean,
  couponType?: string,
  discountCode?: string,
) => {
  const result = await fetch(`/api/v2/payment/trade`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      package_id,
      sub_account_count,
      platform_id,
      is_upgrade: isUpgrade,
      discount_coupon_code: couponType,
      private_domain_code: discountCode,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const getTradeStatus = async (
  account_id: number,
  package_id: number,
  platform_id: number,
  order_id: string,
  resourceKey: string,
) => {
  const result = await fetch(`/api/v2/payment/payment`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      package_id,
      platform_id,
      order_id,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const getOrder = async (account_id: number, resourceKey: string) => {
  const result = await fetch(`/api/v2/payment/order`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      offset: 0,
      limit: 100,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const cancelOrder = async (
  package_id: number,
  order_id: string,
  platform_id: number,
  account_id: number,
) => {
  const result = await fetch(`/api/v2/payment/transaction`, {
    method: "POST",
    body: JSON.stringify({
      package_id,
      account_id,
      platform_id,
      order_id,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": "user.personal.payment.transaction",
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};

export const addSubAccount = async (
  account_id: number,
  user_id_list: string[],
  comment?: string,
) => {
  const result = await fetch(`/api/v2/permission/account`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      user_id_list,
      comment,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": "user.personal.permission.account",
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};
export const deleteSubAccount = async (
  account_id: number,
  user_id_list: string[],
) => {
  const result = await fetch(`/api/v2/permission/remove_account`, {
    method: "POST",
    body: JSON.stringify({
      account_id,
      user_id_list,
    }),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": "user.personal.permission.account.remove",
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};
